<template lang="pug">
transition(name="fade")
  .NameInputOverlay
    .inner
      .title 新記録達成！<br>今月のランキングにランクインしました！
      .record {{wordCountPerMinute + wordCountPerSecond}}
      .inputContainer
        .inputLabel ランキング用の名前を入力
        .inputs
          .input.input-1(
            v-menuHoverSound
            v-menuClickSound
            :class="{ current: currentNameIndex === 0 }"
            @click="handleInputClick(0)"
          ) {{ name[0] }}
          .input.input-2(
            v-menuHoverSound
            v-menuClickSound
            :class="{ current: currentNameIndex === 1 }"
            @click="handleInputClick(1)"
          ) {{ name[1] }}
          .input.input-3(
            v-menuHoverSound
            v-menuClickSound
            :class="{ current: currentNameIndex === 2 }"
            @click="handleInputClick(2)"
          ) {{ name[2] }}
      .visual-keyboard
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('A')") A
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('B')") B
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('C')")  C
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('D')")  D
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('E')")  E
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('F')")  F
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('G')")  G
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('H')")  H
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('I')")  I
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('J')")  J
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('K')")  K
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('L')")  L
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('M')")  M
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('N')")  N
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('O')")  O
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('P')")  P
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('Q')")  Q
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('R')")  R
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('S')")  S
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('T')")  T
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('U')")  U
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('V')")  V
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('W')")  W
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('X')")  X
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('Y')")  Y
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('Z')") Z
        .key(v-menuHoverSound v-menuClickSound @click="handleKeyClick('.')")  .
      km-button.submitButton(
        size="large"
        styleName="primary"
        @click="handleSubmitButtonClick"
      ) 決定
</template>

<script>
// import moment from 'moment'
// import soundService from '@/services/SoundService'

export default {
  name: 'km-name-input-overlay',
  components: {},
  props: {
    wordCountPerMinute: {
      type: String,
      default: ''
    },
    wordCountPerSecond: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentNameIndex: 0,
      name: ['T', 'R', 'Y']
    }
  },
  computed: {},
  methods: {
    handleKeyClick(key) {
      this.$set(this.name, this.currentNameIndex, key)
      this.currentNameIndex++
      if (this.currentNameIndex === 3) this.currentNameIndex = 0
    },
    handleSubmitButtonClick() {
      this.$emit('onSubmit', this.name)
    },
    handleInputClick(index) {
      this.currentNameIndex = index
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.NameInputOverlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;

  .inner {
    padding: 40px;
    width: 80%;
    height: 80%;
    background: rgba(#fff, 1);
    font-size: 3rem;
    text-align: center;
    border-radius: 10px;
    overflow: scroll;
  }

  .title {
    margin: 0 0 20px 0;
    color: orange;
    font-size: 4rem;
  }

  .record {
    margin: 0 -40px 20px;
    padding: 10px;
    background: orange;
    color: #fff;
  }
  .inputContainer {
  }
  .inputLabel {
    margin: 0 0 10px 0;
    font-size: 2rem;
  }
  .inputs {
    display: inline-flex;
    margin: 0 0 20px 0;
  }
  .input {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px 10px 0;
    width: 100px;
    height: 100px;
    border: 2px solid #000;
    font-size: 8rem;

    &.current {
      animation-name: blink;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-direction: alternate;
      animation-timing-function: linear;
      @keyframes blink {
        from {
          background: orange;
        }
        to {
          background: white;
        }
      }
    }
  }

  .visual-keyboard {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 20px 0;
  }

  .key {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px 10px 0;
    width: 50px;
    height: 50px;
    background: #eee;

    &:hover {
      background: #ddd;
    }

    &:active {
      background: orange;
    }
  }

  .submitButton {
    display: inline-block;
    width: 300px;
  }
}
</style>
